import * as React from "react";
import Modal from "../../ui/modal/Modal";
import {OnSuccessData} from "../../../store/action/actionHelpers";
import IndividualContact from "../../../model/contact/IndividualContact";
import EditContactForm from "../form/edit/EditContactForm";

interface Props {
	/**
	 * Contact to edit
	 */
	contact: IndividualContact
	/**
	 * On successfully added individual contact action.
	 */
	onSuccess: OnSuccessData<IndividualContact>
	/**
	 * On close action.
	 */
	onClose: () => void
}

/**
 * Edit individual contact modal view.
 */
export default class EditIndividualContactModal extends React.PureComponent<Props, {}> {

	constructor(props: Props) {
		super(props);
		this.handleCloseModal = this.handleCloseModal.bind(this);
		this.handleOnSuccess = this.handleOnSuccess.bind(this);
	}

	render() {
		return (
			<Modal onCloseClicked={this.handleCloseModal} title={"Edit contact"}>
				<EditContactForm onSuccess={this.handleOnSuccess} contact={this.props.contact} onCancel={this.props.onClose}/>
			</Modal>
		);
	}

	/**
	 * Handle close modal.
	 */
	private handleCloseModal() {
		this.props.onClose();
	}

	/**
	 * Handle successfully updated action.
	 */
	private handleOnSuccess(contact: IndividualContact) {
		this.props.onSuccess(contact);
	}
}